import { PublicationsPageComponent } from './publications-page.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core';

const routes: Routes = [
  {
    path: 'publicaciones-page',
    component: PublicationsPageComponent,
    data: { title: extract('publicaciones-page') }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class PublicationsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/publications-page/publications-page-routing.module.ts